var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLocation = function SvgIconLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #008060;\n        stroke: #008060;\n        stroke-width: 0.25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14850",
    "data-name": "Group 14850",
    transform: "translate(-548 -1246)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3844",
    "data-name": "Rectangle 3844",
    className: "cls-1",
    width: 30,
    height: 30,
    transform: "translate(548 1246)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "map-marker",
    transform: "translate(557 1251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "M6.5,4A2.5,2.5,0,1,1,4,6.5,2.5,2.5,0,0,1,6.5,4Zm0,1A1.5,1.5,0,1,0,8,6.5,1.5,1.5,0,0,0,6.5,5ZM1.8,9.357l4.7,7.729,4.7-7.729h0a5.5,5.5,0,1,0-9.4,0Zm10.254.519L6.5,19.012.946,9.877h0a6.5,6.5,0,1,1,11.11,0Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-location.6f5e97fe.svg";
export { ForwardRef as ReactComponent };